export default "__VITE_ASSET__Bac9jMu2__"